export default {
    getUser (state) {
        return state.user
    },
    getCharacters (state) {
        return state.user.characters
    },
    isLoggedIn (state) {
        return state.isLoggedIn
    },
    getTickets (state) {
        return state.user.tickets
    },
    getNightMarketItems (state) {
        return state.user.night_market_items
    },
    getNightMarket(state) {
        return state.user.night_market
    },
    isAdmin (state) {
        if (state.user) {
            return Number(state.user.UserType) >= 30
        } else {
            return 0
        }
    }
}